// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-table .el-table__body-wrapper[data-v-a80b2c9e] {\n  overflow: auto !important;\n}\n.addStyle[data-v-a80b2c9e] {\n  color: #409EFF;\n  cursor: pointer;\n  font-size: 18px;\n}\n.deleteStyle[data-v-a80b2c9e] {\n  color: #F56C6C;\n  cursor: pointer;\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
